import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { APIgetDownload } from '../api/Downloads';
import { APIgetShareDownload } from '../api/Shares';
import { hideModal } from '../actions';
import { setDownloadUrl } from '../actions/App';
import { removeDownloadRequest } from '../actions/Files';
import {
  addFlashMessage,
  removeFlashMessage,
} from '../helpers/FlashMessages';

class Downloads extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      timer: null,
    };

    this.checkRequests = this.checkRequests.bind(this);
  }

  componentDidUpdate() {
    const { downloadRequests } = this.props;
    const { timer } = this.state;
    if (downloadRequests.length > 0 && !timer) {
      this.setTimer();
    }
    if (downloadRequests.length === 0 && timer) {
      this.resetTimer();
    }
  }

  setTimer() {
    const timer = setInterval(this.checkRequests, 2000);
    this.setState({ timer });
  }

  resetTimer() {
    const { timer } = this.state;
    clearInterval(timer);
    this.setState({ timer: null });
  }

  isDownloadRequestValid(request) {
    const { downloadRequests } = this.props;
    return downloadRequests.find(dr => (dr === request)) || false;
  }

  processDownloadResponse(request, response) {
    const {
      intl,
      deleteDownloadRequest,
      addDownloadUrl,
      hideDownloadModal,
    } = this.props;

    if (response.data.path) {
      if (this.isDownloadRequestValid(request)) {
        const downloadLink = document.createElement('a');
        downloadLink.setAttribute('href', response.data.path);
        downloadLink.setAttribute('id', response.data.uuid);
        if (response.data.filename) {
          downloadLink.setAttribute('download', response.data.filename);
        } else {
          downloadLink.setAttribute('download', response.data.path.split('/').pop().split('?')[0]);
        }
        downloadLink.style.display = 'none';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        addDownloadUrl({
          url: response.data.path,
          fileName: downloadLink.getAttribute('download'),
        });

        deleteDownloadRequest(request);
        removeFlashMessage(request);
      }
    }

    if (response.data.status === 'error') {
      deleteDownloadRequest(request);
      removeFlashMessage(request);
      addFlashMessage({
        type: 'danger',
        text: intl.formatMessage({
          defaultMessage: 'Download failed. Please try again.',
        }),
      });
    }

    if (response.data.status === 'empty') {
      deleteDownloadRequest(request);
      removeFlashMessage(request);
      hideDownloadModal();
      addFlashMessage({
        type: 'warning',
        text: intl.formatMessage({
          defaultMessage: '<strong>Your download was empty</strong>.{br}You probably don\'t have permissions to download selected files.',
        }, { br: '\n' }),
      });
    }
  }

  checkRequests() {
    const {
      downloadRequests,
      share,
    } = this.props;
    downloadRequests.forEach((request) => {
      if (share && share.uuid) {
        APIgetShareDownload(share.uuid, request).then((response) => {
          this.processDownloadResponse(request, response);
        });
      } else {
        APIgetDownload(request).then((response) => {
          this.processDownloadResponse(request, response);
        });
      }
    });
  }

  render() {
    return null;
  }
}

const mapStateToProps = state => ({
  downloadRequests: state.Files.downloadRequests,
  share: state.Shares.share,
});

const mapDispatchToProps = dispatch => ({
  deleteDownloadRequest: (downloadRequestUuid) => {
    dispatch(removeDownloadRequest(downloadRequestUuid));
  },
  addDownloadUrl: (downloadUrl) => {
    dispatch(setDownloadUrl(downloadUrl));
  },
  hideDownloadModal: () => {
    dispatch(hideModal());
  },
});

Downloads.propTypes = {
  intl: PropTypes.object.isRequired,
  downloadRequests: PropTypes.array.isRequired,
  deleteDownloadRequest: PropTypes.func.isRequired,
  addDownloadUrl: PropTypes.func.isRequired,
  hideDownloadModal: PropTypes.func.isRequired,
  share: PropTypes.object,
};

Downloads.defaultProps = {
  share: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Downloads));
